import React, { useEffect, useState } from 'react';

const defaultFormState = {
  name: '',
  code: '',
  primaryContactName: '',
  primaryEmail: '',
  primaryPhone: '',
  paymentTerms: '',
  defaultLeadTimeDays: 7,
  notes: '',
  status: 'Active',
};

const SupplierForm = ({ supplier, onSave, onCancel }) => {
  const [form, setForm] = useState(defaultFormState);

  useEffect(() => {
    if (supplier) {
      setForm({
        ...defaultFormState,
        ...supplier,
      });
    } else {
      setForm(defaultFormState);
    }
  }, [supplier]);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    onSave(form);
  };

  return (
    <form className="space-y-4" onSubmit={handleSubmit}>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700">Supplier Name</label>
          <input
            name="name"
            value={form.name}
            onChange={handleChange}
            required
            className="mt-1 w-full border-gray-300 rounded-md shadow-sm"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700">Supplier Code</label>
          <input
            name="code"
            value={form.code}
            onChange={handleChange}
            className="mt-1 w-full border-gray-300 rounded-md shadow-sm"
            placeholder="Optional unique code"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700">Primary Contact</label>
          <input
            name="primaryContactName"
            value={form.primaryContactName}
            onChange={handleChange}
            className="mt-1 w-full border-gray-300 rounded-md shadow-sm"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700">Email</label>
          <input
            type="email"
            name="primaryEmail"
            value={form.primaryEmail}
            onChange={handleChange}
            className="mt-1 w-full border-gray-300 rounded-md shadow-sm"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700">Phone</label>
          <input
            name="primaryPhone"
            value={form.primaryPhone}
            onChange={handleChange}
            className="mt-1 w-full border-gray-300 rounded-md shadow-sm"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700">Payment Terms</label>
          <input
            name="paymentTerms"
            value={form.paymentTerms}
            onChange={handleChange}
            className="mt-1 w-full border-gray-300 rounded-md shadow-sm"
            placeholder="e.g. Net 30"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700">Lead Time (days)</label>
          <input
            type="number"
            min="0"
            name="defaultLeadTimeDays"
            value={form.defaultLeadTimeDays}
            onChange={handleChange}
            className="mt-1 w-full border-gray-300 rounded-md shadow-sm"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700">Status</label>
          <select
            name="status"
            value={form.status}
            onChange={handleChange}
            className="mt-1 w-full border-gray-300 rounded-md shadow-sm"
          >
            <option value="Active">Active</option>
            <option value="Inactive">Inactive</option>
          </select>
        </div>
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700">Notes</label>
        <textarea
          name="notes"
          value={form.notes}
          onChange={handleChange}
          rows={3}
          className="mt-1 w-full border-gray-300 rounded-md shadow-sm"
        />
      </div>
      <div className="flex justify-end gap-2">
        <button
          type="button"
          className="px-4 py-2 rounded-md border border-gray-300 text-gray-700"
          onClick={onCancel}
        >
          Cancel
        </button>
        <button
          type="submit"
          className="px-4 py-2 rounded-md bg-primary text-white hover:bg-primary-dark"
        >
          {supplier ? 'Update Supplier' : 'Create Supplier'}
        </button>
      </div>
    </form>
  );
};

export default SupplierForm;
